<template>
  <div>
    <BaseFrame
      @save="handleSave"
      @clear="resetModalVisiable = true"
      saveText="保存"
      :save-loading="saveLoading"
      :idText="idText"
      :id="id"
      :infosArr="infosArr">
      <div slot="content">
        <lk-card title="仓库信息">
          <lk-form
            :model="warehouseForm"
            :label-width="140"
            label-position="right"
            ref="warehouseForm"
            :rules="warehouseFormRules"
          >
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="仓库名称:" prop="warehouseName">
                  <lk-input :maxlength="50" v-model.trim="warehouseForm.warehouseName" clearable placeholder="仓库名称"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="10" offset="2">
                <lk-form-item label="仓库属性:" prop="warehouseAttributeSelect">
                  <lk-cascader
                    v-model.trim="warehouseForm.warehouseAttributeSelect"
                    :data="warehouseAttributeList"
                    :disabled="isWarehouseEdit">
                  </lk-cascader>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="管理人员:" prop="managerId">
                  <lk-select v-model="warehouseForm.managerId">
                    <lk-option v-for="item in warehouseManagerList" :value="item.value" :key="item.value">
                      {{ '工号: ' + item.value + ' 姓名: ' + item.label }}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="10" offset="2">
                <lk-form-item label="位置说明:" prop="warehouseAddress">
                  <lk-input :maxlength="50" v-model.trim="warehouseForm.warehouseAddress"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="特殊说明:" prop="warehouseRemark">
                  <lk-input :maxlength="50" v-model.trim="warehouseForm.warehouseRemark" clearable placeholder="特殊说明"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
          <DTPModal v-model="resetModalVisiable" content="重置将取消当前所做更改。" @confirm="handlerRestForm" type="alert"></DTPModal>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import DTPModal from '../../components/DTPModal';
import utils from '../../libs/utils';
import system from '../../services/system';

export default {
  name: 'warehouseForm',
  components: {
    BaseFrame,
    DTPModal,
  },
  computed: {
    isWarehouseEdit() {
      return this.$route.name === 'warehouseEdit';
    },
  },
  data() {
    return {
      id: '',
      idText: '',
      infosArr: [],
      warehouseAttributeList: [], // 仓库属性列表
      warehouseManagerList: [], // 库管员列表
      resetModalVisiable: false,
      warehouseForm: {
        warehouseName: null,
        warehouseAttributeSelect: [], // 仓库[类型, 属性]
        warehouseType: null, // 仓库类型
        warehouseAttributeSign: null, // 仓库属性
        managerId: null,
        managerName: null,
        warehouseAddress: null,
        warehouseRemark: null,
      },
      saveLoading: false,
      warehouseFormRules: {
        warehouseName: [
          {
            required: true,
            message: '请此处为必填项，不能为空',
            trigger: 'blur',
          },
        ],
        warehouseAttributeSelect: [
          {
            required: true,
            message: '请此处为必填项，不能为空',
          },
        ],
        managerId: [
          {
            required: true,
            message: '请此处为必填项，不能为空',
            type: 'number',
          },
        ],
      },
    };
  },
  methods: {
    getWarehouseInfo() {
      inventory.warehouseData({ warehouseId: this.$route.params.id })
        .then((res) => {
          if (res.data.status === 200) {
            const data = res.data.data;
            if (this.isWarehouseEdit) {
              this.id = data.warehouseCode;
              this.idText = '仓库编码';

              this.infosArr = [
                {
                  name: '创建人:',
                  value: data.createUserName,
                },
                {
                  name: '创建时间:',
                  value: utils.exchangeTime(data.createTime),
                },
              ];
            }
            this.warehouseForm = data;
            this.warehouseForm.warehouseAttributeSelect = [data.warehouseType, data.warehouseAttributeSign];
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleSave() {
      this.$refs.warehouseForm.validate((valid) => {
        if (valid) {
          if (this.warehouseForm.warehouseAttributeSelect.length >= 1) {
            const [type, ...attributies] = this.warehouseForm.warehouseAttributeSelect;
            this.warehouseForm.warehouseType = type; // 仓库类型
            this.warehouseForm.warehouseAttributeSign = attributies.pop(); // 仓库属性
          }
          // 组装managerName传递到后台
          const { label: managerName } = this.warehouseManagerList.find(item => item.value === this.warehouseForm.managerId);
          this.warehouseForm.managerName = managerName;

          // 判断新建||修改
          this.saveLoading = true;
          const finalFormAction = this.isWarehouseEdit ? inventory.updateWarehouseData : inventory.saveWarehouseData;
          finalFormAction(this.warehouseForm)
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success(this.isWarehouseEdit ? '更新成功' : '新建成功');
                setTimeout(() => {
                  this.$router.push({
                    name: 'warehouseList',
                  });
                }, 1000);
              } else {
                this.$Message.error(res.data.error);
              }
              this.saveLoading = false;
            })
            .catch((err) => {
              utils.handleError(err);
              this.saveLoading = false;
            });
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    getWarehouseManagerList() {
      const params = {
        page: 1,
        size: 100,
        statusCodeList: [1], // 1启用 2禁用
      };
      system.storeUserList(params)
        .then((res) => {
          if (res.data.status === 200) {
            res.data.data.list.forEach((item) => {
              const { id: value, name: label } = item.sysUser;
              this.warehouseManagerList.push({ value, label });
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getWarehouseAttributeList() {
      return new Promise((resolve) => {
        inventory.warehouseAttributeList()
          .then((res) => {
            if (res.status === 200 && res.data.status === 200) {
              this.warehouseAttributeList = res.data.data;
            } else {
              this.$Message.error(res.data.error);
            }
            resolve();
          });
      });
    },
    handlerRestForm() {
      // 如果是编辑模式，恢复为之前的数据
      if (this.isWarehouseEdit) {
        this.getWarehouseInfo();
      } else {
        this.$refs.warehouseForm.resetFields();
      }
      this.resetModalVisiable = false;
    },
  },
  created() {
    Promise.all([this.getWarehouseManagerList(), this.getWarehouseAttributeList()])
      .then(() => {
        if (this.isWarehouseEdit) {
          this.getWarehouseInfo();
        }
      })
      .catch((err) => {
        utils.handleError(err);
      });
  },
};
</script>

<style lang="less" scoped>
</style>
